module.exports = __webpack_public_path__ + "img/think.98aade2b.png";